/* eslint-disable arrow-body-style */
import { translateTitle } from '../language';

class OrderItemModel {
  constructor(data) {
    this.externalId = data.externalId;
    this.id = data.id;
    this.isSplit = data.isSplit;
    this.itemId = data.itemId;
    this.options = data.options;
    this.orderId = data.orderId;
    this.price = data.price;
    this.priceWithoutTax = data.priceWithoutTax;
    this.productId = data.productId;
    this.quantity = data.quantity;
    this.taxCode = data.taxCode;
    this.taxPercent = data.taxPercent;
    this.title = data.title;
    this.titleEN = data.titleEN;

    this.init();
  }

  init() {
    this.calculateTotalPrice();
  }

  getTitle() {
    return translateTitle(this);
  }

  // eslint-disable-next-line class-methods-use-this
  getOptionStringArray() {
    const strings = [];
    const selectedOptions = this.getSelectedOptions();
    selectedOptions.forEach((optionGroup) => {
      const line = [];
      optionGroup.options.forEach((option) => {
        if (option.quantity !== 0) {
          let title = translateTitle(option);
          if (option.quantity > 1) {
            title += ` x${option.quantity}`;
          }
          line.push(title);
        }
      });
      strings.push(line.join(', '));
    });

    return strings;
  }

  getOptionString() {
    const strings = this.getOptionStringArray();
    return strings.join(', ');
  }

  calculateTotalPrice() {
    let totalPriceImpact = 0;

    this.options.forEach((option) => {
      if (option.quantity > 0) {
        // Price is always returned as option.price * quantity so no need to multiple with quantity
        totalPriceImpact += option.price;
      }
    });

    this.price += totalPriceImpact;
  }

  getSelectedOptions() {
    const optionsArray = [];
    const options = JSON.parse(JSON.stringify(this.options));

    options.forEach((option) => {
      const optionIndex = optionsArray.findIndex((i) => i.optionId === option.optionId);

      // Create a new array depending on the optionId
      if (optionIndex < 0) {
        optionsArray.push({
          optionId: option.optionId,
          options: [
            option,
          ],
        });
      } else {
        optionsArray[optionIndex].options.push(option);
      }
    });
    return optionsArray;
  }
}

export default OrderItemModel;
